'use client';

import { Button } from '@petsmart-ui/sparky';

import { useMiniPdpDrawer } from './model/useMiniPdpDrawer';
import type { MiniPdpDrawerOptions } from './types';

export function MiniPdpCTA({ productId }: Readonly<MiniPdpDrawerOptions>) {
    const open = useMiniPdpDrawer(state => state.open);

    if (!productId) return null;

    return (
        <Button
            text="Add to cart"
            fullWidth
            onClick={event => {
                event.stopPropagation();
                open({ productId });
            }}
            data-testid="mini-pdp-cta"
        />
    );
}
